<template>
  <div class="container mt-4">
    <h1>Категоризация Ингредиентов</h1>
    <p class="text-muted">
      Здесь отображаются все ингредиенты. Вы можете изменить категорию для
      любого из них.
    </p>

    <div v-if="isLoading" class="text-center mt-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Загрузка...</span>
      </div>
    </div>

    <div v-else-if="error" class="alert alert-danger mt-3">
      {{ error }}
    </div>

    <div v-else-if="allIngredients.length === 0" class="alert alert-info mt-3">
      В базе данных нет ингредиентов.
    </div>

    <div v-else>
      <div class="form-check form-switch mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="showOnlyUncategorized"
          v-model="showOnlyUncategorized"
        />
        <label class="form-check-label" for="showOnlyUncategorized"
          >Показать только без категории</label
        >
      </div>

      <div v-if="filteredIngredients.length > 0" class="table-responsive">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th scope="col">Ингредиент</th>
              <th scope="col">Категория</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ingredient in filteredIngredients" :key="ingredient.id">
              <td>{{ ingredient.name }}</td>
              <td>
                <select
                  class="form-select"
                  :value="ingredient.category_id"
                  @change="
                    updateIngredientCategory(ingredient, $event.target.value)
                  "
                >
                  <option value="0" disabled>Выберите категорию...</option>
                  <option
                    v-for="category in categories"
                    :key="category.id"
                    :value="category.id"
                  >
                    {{ category.name }}
                  </option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="alert alert-info mt-3">
        Нет ингредиентов, соответствующих вашему фильтру.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageAdminIngredients",
  data() {
    return {
      allIngredients: [],
      categories: [],
      isLoading: true,
      error: null,
      showOnlyUncategorized: true,
    };
  },
  computed: {
    filteredIngredients() {
      if (this.showOnlyUncategorized) {
        return this.allIngredients.filter(
          (ingredient) =>
            !ingredient.category_id || ingredient.category_id === 0
        );
      }
      return this.allIngredients;
    },
  },
  async mounted() {
    try {
      const [ingredientsResponse, categoriesResponse] = await Promise.all([
        this.sendCmd("ingredients.list.all"),
        this.sendCmd("ingredient.categories.list"),
      ]);
      this.allIngredients = JSON.parse(ingredientsResponse);
      this.categories = JSON.parse(categoriesResponse);
    } catch (err) {
      console.error("Failed to load data for ingredient categorization:", err);
      this.error = "Не удалось загрузить данные. Попробуйте позже.";
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async updateIngredientCategory(ingredient, categoryId) {
      if (!categoryId) return;
      try {
        const command = `ingredient.setCategory/${ingredient.id}/${categoryId}`;
        await this.sendCmd(command);
        // Update the local data model for instant feedback
        ingredient.category_id = parseInt(categoryId, 10);
      } catch (err) {
        console.error(
          `Failed to update category for ingredient ${ingredient.id}:`,
          err
        );
        // Optionally show a toast notification for the error
      }
    },
  },
};
</script>
